import Scroller from '../plugins/scroller';

(() => {
  (window as any).Scroller = new Scroller();
})();
